enum UserRole {
  SYSADMIN = 'sysadmin',
  MANAGER = 'manager',
  SUPERUSER = 'superuser',
  USER = 'user',
  EXTERNAL_USER = 'external_user'
}

export default UserRole;
